var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherTabsSwitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9870_8436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0861 9.70703H11.3125C10.7085 9.70703 10.2188 10.1967 10.2188 10.8008V36.5744C10.2188 37.1785 10.7085 37.6682 11.3125 37.6682H37.0861C37.6902 37.6682 38.1799 37.1785 38.1799 36.5744V10.8008C38.1799 10.1967 37.6902 9.70703 37.0861 9.70703Z",
    fill: "#FE907A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0821 9.70703H24.1953V37.6682H37.0821C37.6861 37.6682 38.1758 37.1785 38.1758 36.5744V10.8008C38.1758 10.1967 37.6861 9.70703 37.0821 9.70703Z",
    fill: "#FC5B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3947 5.02148H6.62109C6.01705 5.02148 5.52734 5.51119 5.52734 6.11523V31.8889C5.52734 32.4929 6.01705 32.9826 6.62109 32.9826H32.3947C32.9988 32.9826 33.4885 32.4929 33.4885 31.8889V6.11523C33.4884 5.51112 32.9988 5.02148 32.3947 5.02148Z",
    fill: "#FFD680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3985 5.02148H19.5117V32.9826H32.3985C33.0025 32.9826 33.4923 32.4929 33.4923 31.8889V6.11523C33.4923 5.51112 33.0026 5.02148 32.3985 5.02148Z",
    fill: "#FFBB25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7111 0.334961H1.9375C1.33346 0.334961 0.84375 0.824669 0.84375 1.42871V24.4063H26.4619C27.7559 24.4063 28.8049 23.3572 28.8049 22.0633V1.42871C28.8049 0.824669 28.3152 0.334961 27.7111 0.334961Z",
    fill: "#82D4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8048 22.0632V1.42871C28.8048 0.824669 28.3151 0.334961 27.7111 0.334961H14.8242V24.4063H26.4617C27.7558 24.4063 28.8048 23.3572 28.8048 22.0632Z",
    fill: "#38B1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4262 21.7429L9.74002 17.0567C9.53491 16.8516 9.25673 16.7363 8.96667 16.7363C8.6766 16.7363 8.39843 16.8516 8.19331 17.0567L0.84375 24.4063V27.2023C0.84375 27.8064 1.33346 28.2961 1.9375 28.2961H6.32614C8.30692 28.2961 10.2065 27.5093 11.6071 26.1086L14.4262 23.2896C14.8533 22.8625 14.8533 22.17 14.4262 21.7429Z",
    fill: "#733266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7092 28.2955H6.32422L19.9066 14.713C20.1117 14.5079 20.3899 14.3926 20.68 14.3926C20.97 14.3926 21.2482 14.5079 21.4533 14.713L28.8028 22.0625V27.2017C28.803 27.8057 28.3133 28.2955 27.7092 28.2955Z",
    fill: "#5A1A56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8048 27.2017V22.0626L21.4552 14.713C21.2501 14.5079 20.9719 14.3926 20.6818 14.3926C20.3918 14.3926 20.1136 14.5079 19.9085 14.713L14.8242 19.7972V28.2954H27.711C28.315 28.2955 28.8048 27.8057 28.8048 27.2017Z",
    fill: "#410D4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.079 12.888C19.8784 11.0886 19.8784 8.17119 18.079 6.37179C16.2796 4.5724 13.3622 4.5724 11.5628 6.37179C9.76338 8.17119 9.76339 11.0886 11.5628 12.888C13.3622 14.6874 16.2796 14.6874 18.079 12.888Z",
    fill: "#FFD680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4326 9.62982C19.4326 7.08875 17.3653 5.02148 14.8242 5.02148V14.2382C17.3653 14.2382 19.4326 12.1708 19.4326 9.62982Z",
    fill: "#FFBB25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9870_8436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3333,
    height: 37.3333,
    fill: "white",
    transform: "translate(0.832031 0.333984)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTabsSwitcher);
export default __webpack_public_path__ + "static/media/other_tabs_switcher.cbecbd822c33a43955c74c8224093948.svg";
export { ForwardRef as ReactComponent };